import { type ActionItem, toastStore } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { ReviewActionsStore } from 'pages/reviews/store/reviewActionsStore'
import { ReviewsRoutes } from 'pages/reviews/route/type'

export const reviewActionsStore = new ReviewActionsStore()

export const getReviewActions = ({
  item,
  onSuccessDelete,
}: {
  item: { id: number; shortUrl: string }
  onSuccessDelete?: () => void
}): ActionItem[] => [
  {
    text: 'Copy link',
    icon: 'link',
    onAction: () => {
      writeTextToClipboard(item.shortUrl)
      toastStore.add({ type: 'info', title: 'Copied' })
    },
  },
  {
    text: 'Edit',
    icon: 'edit',
    onAction: () =>
      uiStore.changeRouteViaVue({
        path: `/${ReviewsRoutes.root}/${ReviewsRoutes.edit}/${item.id}`,
      }),
  },
  {
    text: 'Duplicate',
    icon: 'copy',
    onAction: () =>
      uiStore.changeRouteViaVue({
        path: `/${ReviewsRoutes.root}/${ReviewsRoutes.clone}/${item.id}`,
      }),
  },
  {
    text: 'Delete',
    icon: 'delete',
    onAction: () => reviewActionsStore.onDelete(item.id, onSuccessDelete),
  },
]
